export default __webpack_public_path__ + "static/media/projectSakura.e0f05375.png";